module.exports = __webpack_public_path__ + "static/media/High School Hackers Meet-Up.a7adb928.png";